import { useContext } from 'react'

import { AppContext } from 'contexts/AppContext'

import { Logo2 } from 'components/Icons'
import { Link } from 'react-router-dom'
import { AuthContext } from 'contexts/AuthContext'
import { RouteNamesAuth } from 'routes/enum'

export const Header = () => {
  const { isSignedIn, currentBroker } = useContext(AuthContext)
  const { backOfficeMode, settings } = useContext(AppContext)

  const barText = settings?.contact_bar_text || ''

  if (!isSignedIn) return <></>

  return (
    <div className="w-full h-auto flex flex-col relative">
      <div className="h-[85px] flex items-center justify-between w-full px-5 relative">
        <Link
          className="mt-4 mb-4 h-16 w-60"
          to={
            backOfficeMode
              ? RouteNamesAuth.BACKOFFICE_DASHBOARD
              : RouteNamesAuth.DASHBOARD
          }
        >
          <Logo2 />
        </Link>
        <div className="hidden lg:flex absolute right-0 top-0 lg:top-auto lg:bottom-0 bg-MenuRed w-fit items-end">
          {backOfficeMode && (
            <div className="bg-metal-200 text-metal-900 text-body-4 h-9 rounded-b-md lg:rounded-b-none lg:rounded-t-md border-2 px-4 flex items-center">
              Broker Emulado: {currentBroker?.BrokerName}
            </div>
          )}
          <div className="bg-primary-600 text-white text-body-4 h-9 rounded-b-md lg:rounded-b-none lg:rounded-t-md border-2 px-4 flex items-center">
            {barText}
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 bg-primary-900 h-2 w-full"></div>
    </div>
  )
}
